import React, { Component } from "react";
import { Row, Col, Container } from "reactstrap";
import { connect } from "react-redux";
import CurrencyFormat from "react-currency-format";
import Rut from "rutjs";
import { map, find } from 'lodash';
import { getMonths, getParam } from "../../../redux/actions";
import {
  employmentSituationOpts,
  nationalityOpts,
  typeContractOpts,
  typeRentOpts
} from "../../../helpers/constants";
import {captchaVerify} from '../../../helpers/captcha'
import {currencyToInt} from "../../../helpers/functions";
import PropTypes from 'prop-types';

const CAPTCHA_FLAG = process.env.REACT_APP_CAPTCHA_FLAG;
const TOKEN_CAPTCHA = process.env.REACT_APP_CAPTCHA_SITE;
const NO_INCOME_LIST = JSON.parse(process.env.REACT_APP_VEHICLES_NO_INCOME);
const porcPieMin = 40;
const MIN_ANTIQUITY_FLAG = process.env.REACT_APP_MIN_ANTIQUITY;

class UserData extends Component {

  static propTypes = {
    getParam: PropTypes.func.isRequired,
    getMonths: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    loadingMonths: PropTypes.bool.isRequired,
    monthsList: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
    const step1 = JSON.parse(localStorage.getItem("step1"));
    let step2 = JSON.parse(localStorage.getItem("step2"));
    let name = '';
    let lastName = '';
    let motherLastName = '';
    let rut = '';
    let email = '';
    let phone = '';
    let monthlyIncome = '';
    let employmentSituation = '';
    let employmentSituationDescription = '';
    let laborOld = '';
    let typeRent = '';
    let typeRentDescription = '';
    let typeContract = '';
    let typeContractDescription = '';
    let nationality = '';
    let nationalityDescription = '';
    let address = '';
    let minIncome = process.env.REACT_APP_MIN_INCOME;
    let minIncomeFlag = '';
    let minAntiquity = '';
    let antiquityFlag = false;

    if (step2) {
      name = step2.name;
      rut = step2.rut;
      lastName = step2.lastName;
      motherLastName = step2.motherLastName;
      email = step2.email;
      phone = step2.phone;
      monthlyIncome = step2.monthlyIncome;
      employmentSituation = step2.employmentSituation;
      employmentSituationDescription = step2.employmentSituationDescription;
      laborOld = step2.laborOld;
      typeRent = step2.typeRent;
      typeRentDescription = step2.typeRentDescription;
      typeContract = step2.typeContract;
      typeContractDescription = step2.typeContractDescription;
      nationality = step2.nationality;
      nationalityDescription = step2.nationalityDescription;
      address = step2.address;
      minIncome = step2.minIncome;
      minIncomeFlag = step2.minIncomeFlag;
      antiquityFlag = step2.antiquityFlag;
      minAntiquity = step2.minAntiquity;
    }

    const search = window.location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);

    if (params.get('firstName')) {
      name = params.get('firstName');
    }
    if (params.get('lastName')) {
      lastName = params.get('lastName');
    }

    if (params.get('rut')) {
      rut = params.get('rut');
    }

    if (params.get('phone')) {
      phone = params.get('phone');
    }

    if (params.get('email')) {
      email = params.get('email');
    }

    const __ret = this.constructorStep1(step1, minIncomeFlag, antiquityFlag);
    minIncomeFlag = __ret.minIncomeFlag;
    antiquityFlag = __ret.antiquityFlag;

    this.state = {
      name: name,
      rut: rut,
      lastName: lastName,
      motherLastName: motherLastName,
      email: email,
      phone: phone,
      monthlyIncome: monthlyIncome,
      employmentSituation: employmentSituation,
      employmentSituationDescription: employmentSituationDescription,
      laborOld: laborOld,
      typeRent: typeRent,
      typeRentDescription: typeRentDescription,
      typeContract: typeContract,
      typeContractDescription: typeContractDescription,
      nationality: nationality,
      nationalityDescription: nationalityDescription,
      address: address,
      messageRut: undefined,
      messageIngresos: '',
      search: search,
      illegalPhone: false,
      illegalIncome: false,
      messageCaptcha: undefined,
      minIncome: minIncome,
      minIncomeFlag: minIncomeFlag,
      antiquityFlag: antiquityFlag,
      messageAntiquity: undefined,
      minAntiquity: minAntiquity
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  constructorStep1(step1, minIncomeFlag, antiquityFlag) {
    if (step1) {
      // PARA AUTOS
      if (step1.vehicleType === 1) {
        minIncomeFlag = 'validacion.sueldo.auto';
      }
      // PARA MOTOS
      if (step1.vehicleType === 5) {
        minIncomeFlag = 'validacion.sueldo.moto';
      }
      if (NO_INCOME_LIST.includes(step1.vehicleType)) {
        minIncomeFlag = false;
      }
      console.log("MIN_ANTIQUITY_FLAG " + MIN_ANTIQUITY_FLAG);
      if (MIN_ANTIQUITY_FLAG === 'true') {
        const porcentaje = (step1.footClean / step1.priceClean) * 100;
        const intPorcentaje = Math.round(porcentaje);
        if (intPorcentaje < porcPieMin) {
          antiquityFlag = true;
        }
      }
    }
    return {minIncomeFlag, antiquityFlag};
  }

  componentDidMount = async () => {
    await this.props.getMonths();
    if(this.state.minIncomeFlag) {
      await this.minIncome();
    }
    if(this.state.antiquityFlag) {
      await this.minAntiquity();
    }
  }

  minIncome = async () => {
    await this.props.getParam(this.state.minIncomeFlag, (res) => {
      this.setState({
        minIncome: res?.value || this.state.minIncome,
      });
    });
  };

  minAntiquity = async () => {
    await this.props.getParam('validacion.antiguedadLaboral.meses', (res) => {
      this.setState({
        minAntiquity: res?.value || this.state.minAntiquity,
      })
    })
  }

  async handleSubmit(event) {
    event.preventDefault();

    let res = 200;
    if (CAPTCHA_FLAG === 'true') {
      await window.grecaptcha.ready(async function () {
        window.grecaptcha.execute(TOKEN_CAPTCHA, {action: 'submit'}).then(async function (token) {
          res = await captchaVerify(token);
        });
      });
    }
    if(res !== 200) {
      this.setState({messageCaptcha: 'ReCaptcha no pudo ser validado.'});
      return;
    }

    let rut = new Rut(this.state.rut);

    if (!rut.isValid) {
      this.setState({ messageRut: 'rut invalido' });
    }

    rut = rut.getNiceRut(false);
    const arrRut = rut.split('-');
    const numRut = parseInt(arrRut[0]);

    if (numRut <= 3000000) {
      this.setState({ messageRut: 'rut debe ser mayor a 3.000.000' });
      return;
    }

    let monthlyIncome;
    monthlyIncome = this.state.monthlyIncome.replace("$", "");
    monthlyIncome = monthlyIncome.split(".").join("");
    monthlyIncome = parseInt(monthlyIncome);

    if(this.state.minIncomeFlag) {

      if (monthlyIncome <= 0) {
        this.setState({ messageIngresos: 'El ingreso mensual debe ser mayor a $0' });
        return;
      }
      if (monthlyIncome > 150000000) {
        this.setState({ messageIngresos: 'El ingreso mensual no puede ser mayor a $150.000.000' });
        return;
      }
    } else if (monthlyIncome <= 0) {
      this.setState({monthlyIncome: "$1"});
    }

    if (this.state.phone.length !== 9) {
      this.setState({ illegalPhone: true });
    } else {
      this.setState({ illegalPhone: false });
      localStorage.setItem("step2", JSON.stringify(this.state));
      this.props.history.push("/page/summary" + this.state.search);
    }
  }

  onChangeMonth = (e) => {
    this.setState({ laborOld: e });
    this.setState({ messageAntiquity: (this.validateAntiquity(e)) ? undefined : `Se requiere un pie de al menos ${porcPieMin}%`});
  }

  onChange = key => event => {
    const state = { ...this.state };
    let value = event.target.value;
    let opts;
    if (key === 'nationality') {
      opts = find(nationalityOpts, (item) => (value === item.value));
      Object.assign(
        state,
        { nationalityDescription: opts ? opts.text : '' }
      );
    }
    if (key === 'employmentSituation') {
      opts = find(employmentSituationOpts, (item) => (value === item.value));
      Object.assign(
        state,
        { employmentSituationDescription: opts ? opts.text : '' }
      );
    }
    if (key === 'typeContract') {
      opts = find(typeContractOpts, (item) => (value === item.value));
      Object.assign(
        state,
        { typeContractDescription: opts ? opts.text : '' }
      );
    }
    if (key === 'typeRent') {
      opts = find(typeRentOpts, (item) => (value === item.value));
      Object.assign(
        state,
        { typeRentDescription: opts ? opts.text : '' }
      );
    }
    Object.assign(state, { [key]: value });
    this.setState(state);

    if (key === 'phone') {
      if (value.length !== 9) {
        this.setState({ illegalPhone: true });
      } else {
        this.setState({ illegalPhone: false });
      }
    }

    if (key === 'monthlyIncome' && this.state.minIncomeFlag) {
      if (value.length < 8) {
        this.setState({ illegalIncome: 'Número debe tener al menos 6 dígitos' });
        } else if (currencyToInt(value) < currencyToInt(this.state.minIncome)) {
          this.setState({ illegalIncome: `El ingreso mínimo es $ ${this.state.minIncome}` });
      } else {
        this.setState({ illegalIncome: undefined });
      }
    }
  };

  onChangeRut = (rut) => {
    let cleanRut = rut.replace(/[.-]/g, '');
    this.setState({
      messageRut: this.validateRUT(rut) && (cleanRut.length >= 8 && cleanRut.length <= 10) ? undefined : 'Rut ingresado no es válido',
      rut
    });
  }

  goToBack = () => {
    const step1 = JSON.parse(localStorage.getItem("step1"));
    this.props.history.push("/" + step1.idConcesionaria + this.state.search);
  };

  onBlurRut = () => {
    if (this.state.rut) {
      const rut = new Rut(this.state.rut);
      this.setState({ rut: rut.getNiceRut() });
    }
  }

  validateRUT = rut => {
    if (!rut) return true;
    return (new Rut(rut)).isValid;
  }

  validateAntiquity = e => {
    if(this.state.antiquityFlag) {
      // X meses de antiguedad laboral minimo para solicitudes con un pie menor a 40%
      if(parseInt(e) < parseInt(this.state.minAntiquity)) {
        return false;
      }
    }
    return true;
  }

  render() {
    return (
      <Container>
        <Row>
          <Col md={8} className="offset-md-2 ">
            <form onSubmit={this.handleSubmit} className="card-shadow p-4">
              <div>
                <div className="title-page">Simula tu crédito</div>
                <div className="line-h1 mb-4"></div>
                <div className="sub-title-page mb-4">Datos personales</div>
              </div>
              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Nombre</label>
                    <input
                      type="text"
                      required
                      onChange={this.onChange("name")}
                      value={this.state.name}
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Nombre"
                      maxLength="50"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Apellido paterno</label>
                    <input
                      type="text"
                      required
                      onChange={this.onChange("lastName")}
                      value={this.state.lastName}
                      id="lastName"
                      name="lastName"
                      className="form-control"
                      placeholder="Apellido paterno"
                      maxLength="50"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Apellido materno</label>
                    <input
                      type="text"
                      required
                      onChange={this.onChange("motherLastName")}
                      value={this.state.motherLastName}
                      id="motherLastName"
                      name="motherLastName"
                      className="form-control"
                      placeholder="Apellido materno"
                      maxLength="50"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Rut</label>
                    <input
                      type="text"
                      required
                      onChange={(e) => this.onChangeRut(e.target.value)}
                      onBlur={this.onBlurRut}
                      value={this.state.rut}
                      id="rut"
                      name="rut"
                      className="form-control"
                      placeholder="rut"
                      maxLength={12}
                    />
                    {this.state.messageRut &&
                      <span className="error-length">{this.state.messageRut}</span>
                    }
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Email</label>
                    <input
                      type="email"
                      required
                      onChange={this.onChange("email")}
                      value={this.state.email}
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Ingrese su correo electronico"
                      maxLength="50"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className={this.state.illegalPhone ? 'error-input' : 'form-group'}>
                    <label className="labe-simulation-home">Teléfono</label>
                    <div className="sm-phone-form">
                      <input
                        type='text'
                        disabled
                        value='+56'                        
                        className="form-control sm-phone-code"
                      />
                      <input
                        type="phone"
                        required
                        onChange={this.onChange("phone")}
                        value={this.state.phone}
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="912345678"
                        maxLength='9'
                      />
                    </div>
                  </div>
                  {this.state.illegalPhone &&
                    <span className="error-length">Número debe tener 9 dígitos</span>
                  }
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Nacionalidad
                    </label>
                    <select
                      required
                      onChange={this.onChange("nationality")}
                      value={this.state.nationality}
                      id="nationality"
                      name="nationality"
                      className="form-control"
                    >
                      {
                        map(nationalityOpts, ({ value, text }) => (
                          <option key={`nac-${value}`} value={value}>{text}</option>
                        ))
                      }
                    </select>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Dirección</label>
                    <input
                      type="text"
                      required
                      onChange={this.onChange("address")}
                      value={this.state.address}
                      id="address"
                      name="address"
                      className="form-control"
                      placeholder="Dirección"
                      maxLength="100"
                    />
                  </div>
                </Col>
              </Row>

              <Row>

                <Col md={6}>
                  <div className={this.state.illegalIncome ? 'error-input' : 'form-group'}>
                    <label className="labe-simulation-home" htmlFor="monthlyIncome">
                      Ingresos mensuales
                    </label>
                    {this.state.minIncomeFlag && (
                        <div style={{color: 'gray', fontSize: '14px', marginTop: '-.5rem'}}>
                          (Min. ${this.state.minIncome})
                        </div>
                    )}
                    <CurrencyFormat
                      name="monthlyIncome"
                      className="form-control"
                      onChange={this.onChange("monthlyIncome")}
                      value={this.state.monthlyIncome}
                      decimalSeparator=","
                      thousandSeparator="."
                      prefix={"$"}
                      disabled={this.state.loading}
                      id="monthlyIncome"
                      placeholder="Ingreso Mensual"
                      required
                      maxLength="12"
                    />
                  </div>
                  {this.state.messageIngresos && (
                    <div style={{ color: "red" }}>
                      {this.state.messageIngresos}
                    </div>
                  )}
                  {this.state.illegalIncome &&
                    <span className="error-length">{this.state.illegalIncome}</span>
                  }
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Situación Laboral
                    </label>
                    <select
                      required
                      onChange={this.onChange("employmentSituation")}
                      value={this.state.employmentSituation}
                      id="employmentSituation"
                      name="employmentSituation"
                      className="form-control"
                    >
                      {
                        map(employmentSituationOpts, ({ value, text }) => (
                          <option key={`emp-${value}`} value={value}>{text}</option>
                        ))
                      }
                    </select>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Tipo de contrato
                    </label>
                    <select
                      required
                      onChange={this.onChange("typeContract")}
                      value={this.state.typeContract}
                      id="typeContract"
                      name="typeContract"
                      className="form-control"
                    >
                      {
                        map(typeContractOpts, ({ value, text }) => (
                          <option key={`con-${value}`} value={value}>{text}</option>
                        ))
                      }
                    </select>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Tipo de renta
                    </label>
                    <select
                      required
                      onChange={this.onChange("typeRent")}
                      value={this.state.typeRent}
                      id="typeRent"
                      name="typeRent"
                      className="form-control"
                    >
                      {
                        map(typeRentOpts, ({ value, text }) => (
                          <option key={`ren-${value}`} value={value}>{text}</option>
                        ))
                      }
                    </select>
                  </div>
                </Col>


                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Antigüedad laboral
                    </label>
                    {this.state.antiquityFlag && (
                        <div style={{color: 'gray', fontSize: '14px', marginTop: '-.5rem'}}>
                          Para antiguedad menor a {this.state.minAntiquity} meses es requerido un pie minimo del {porcPieMin}%
                        </div>
                    )}
                    <select
                      required
                      onChange={(e) => this.onChangeMonth(e.target.value)}
                      value={this.state.laborOld}
                      disabled={this.props.loadingMonths}
                      id="laborOld"
                      name="laborOld"
                      className="form-control"
                    >
                      <option value=''>Seleccione</option>
                      {
                        map(this.props.monthsList, (e) => (
                          <option key={e.id} value={e.value}>{e.description}</option>
                        ))
                      }
                    </select>
                    {this.state.messageAntiquity &&
                        <span className="error-length">{this.state.messageAntiquity}</span>
                    }
                  </div>
                </Col>
              </Row>

              {this.state.messageCaptcha && (
                  <div style={{color: "red" }}>
                    {this.state.messageCaptcha}
                  </div>
              )}
              <Row>
                <div className="text-center w-100">
                  <button
                    onClick={this.goToBack}
                    type="button"
                    className="btn button-back mt-4 mr-4"
                  >Volver</button>

                  <button type="submit" className="btn button-next mt-4" disabled={this.state.illegalPhone || this.state.illegalIncome || this.state.messageRut || this.state.messageAntiquity}>
                    Siguiente
                  </button>
                </div>
              </Row>
              <Row>
                <div style={{ color: 'gray', fontSize: '12px', textAlign: 'justify', marginTop:'2%' }}>
                  <p>
                    Este sitio es protegido por reCAPTCHA y las politicas de privacidad de Google
                    <a href="https://policies.google.com/privacy"> Políticas de Privacidad</a> ciertos
                    <a href="https://policies.google.com/terms"> Términos y condiciones</a> Aplican.
                  </p>
                </div>
              </Row>
            </form>
          </Col>

        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  monthsList: state.spider.monthsList,
  loadingMonths: state.spider.loadingMonths,
});

const mapDispatchToProps = {
  getMonths,
  getParam
};
export default connect(mapStateToProps, mapDispatchToProps)(UserData);
